/** @file Config.js
  * @brief Stores all the configuration for this application
  *
  * @author Justin Eslinger - Fivestone Studios
  * @date 07/23/2020
  *
  */

/**
 * Amazon Gateway API for Lamda function CTE-CreateJob
 */
export const apiCreateJob = "https://gkaq7y9ww9.execute-api.us-east-2.amazonaws.com/default/CTE-CreateJob";

/**
 * Amazon S3 bucket
 */
export const s3Config = {
  bucketName: 'fivestone-cte',
  region: 'us-east-2',
  accessKeyId: 'AKIAUOZ26FLU34EOOPJ7',
  secretAccessKey: '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',
}

export const mediaConstraints = {
  audio: false,
  video: true
};